// extracted by mini-css-extract-plugin
module.exports = {"table":"Charges_table__1nvoO","colHead":"Charges_colHead__1HPgm","colMinPrice":"Charges_colMinPrice__2JkqI","colTargetPrice":"Charges_colTargetPrice__24axF"};